import i18next from "i18next";
import React from "react";
import { useTranslation } from "react-i18next";
import { Provider as ReduxProvider } from "react-redux";
import { BrowserRouter } from "react-router";
import { CloseButtonProps, ToastContainer } from "react-toastify";
import { ConfigProvider } from "src/providers/ConfigProvider";
import { ThemeProvider } from "src/providers/ThemeProvider";
import store from "src/store";
import Router from "src/ui/navigation/Router";

import { SubscriptionExpirationBanner } from "@dashboard/workspaces/components/SubscriptionExpirationBanner/SubscriptionExpirationBanner";
import { withMetaDescription } from "@navigation/utils/withMetaDescription";

import AnalyticService from "./services/analyticService";
import { Navigation } from "./ui/navigation/Navigation";

const ToastCloseButton = (props: CloseButtonProps) => {
    const onClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        props.closeToast(true);
    };

    return (
        <button
            type="button"
            className={`Toastify__close-button Toastify__close-button--${props.theme}`}
            onClick={onClick}
            aria-label={i18next.t("common:button.close")}
        >
            <i className="fa-solid fa-xmark" aria-hidden="true" />
        </button>
    );
};

const AppContentWithMeta = withMetaDescription(() => {
    const { t } = useTranslation(["common"]);

    React.useEffect(() => {
        AnalyticService.initialize();
    }, []);

    return (
        <React.Fragment>
            <SubscriptionExpirationBanner />
            <ToastContainer
                style={{ top: "74px", right: "10px" }}
                theme="colored"
                stacked
                limit={5}
                aria-label={t("common:aria.notifications")}
                closeButton={ToastCloseButton}
            />
            <Navigation>
                <Router />
            </Navigation>
        </React.Fragment>
    );
}, {});

const App = () => {
    const domain = window.location.hostname;
    if (domain === "hub.jkc.emteria.com") {
        // temporary redirect to new Kenwood URL
        window.location.href = "https://mdm.kenwood.com";
    }

    return (
        <ReduxProvider store={store}>
            <BrowserRouter basename={import.meta.env.BASE_URL}>
                <ThemeProvider>
                    <ConfigProvider>
                        <AppContentWithMeta />
                    </ConfigProvider>
                </ThemeProvider>
            </BrowserRouter>
        </ReduxProvider>
    );
};

export default App;
